import React from 'react'
import styled from '@emotion/styled'
import { AppRoutes } from '@core/AppRoutes'
import { VenueIconButton } from './VenueIconButton'
import { useNavigate } from 'react-router'
import { getCoords } from '@core/Areas/VenueMode/Store'
import { useSelector } from 'react-redux'
import { trackVenueModeHeaderClick } from './analytics'
import { useIsVenueModeActive } from '@core/Areas/VenueMode/Hooks/useIsVenueModeActive'
import { Tooltip } from '@mobi/component-library/Common/V2/Tooltip'
import { useLocalstorageState } from 'rooks'
import { VENUE_FEATURE_NAME_SINGULAR } from '@core/Areas/VenueMode/constants'

export const VenueModeHeaderButton: React.FC = () => {
  const isActiveVenueEnabled = useIsVenueModeActive()
  const geoLocation = useSelector(getCoords)
  const isInside = geoLocation.closestVenue?.inside == true
  const navigate = useNavigate()
  const venueIconButtonRef = React.useRef<HTMLButtonElement>(null)

  const [hasSeenTooltip, setHasSeenTooltip] = useLocalstorageState<boolean>(
    'tooltip:venue-mode-header-button',
    false
  )

  if (!isActiveVenueEnabled) return null

  const handleNavigate = () => {
    trackVenueModeHeaderClick()
    navigate(AppRoutes.VenueMode)
  }

  return (
    isActiveVenueEnabled &&
    isInside && (
      <>
        <VenueIconButton ref={venueIconButtonRef} onClick={handleNavigate} />

        <Tooltip
          color='blue'
          triggerElRef={venueIconButtonRef}
          tooltipId='venue-mode-header-button'
          hasTooltipBeenSeen={() => hasSeenTooltip}
          onDismissed={() => setHasSeenTooltip(true)}
          shouldHideCrossIcon
          shouldOnlyRenderSingleInstance={true}
          offsetYPx={7}
          offsetXPx={8}
          strategyPosition='fixed'
          preferredPlacement='bottom'
        >
          <TooltipContent>
            <div>Access {VENUE_FEATURE_NAME_SINGULAR}</div>
            <div>benefits here</div>
          </TooltipContent>
        </Tooltip>
      </>
    )
  )
}

const TooltipContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  minWidth: '11.2rem',
})
